import { mapGetters, mapState} from 'vuex'
    const minXin = {
    data() {
        return {

        }
    },
    computed:{
        ...mapState([
            'index'
          ]),
          // 元宇宙会议
          yxc() {
            if(this.index.webColunmsList.filter(c => {return c.link == 'ConfigureImage'}).length > 0) {
                let ConfigureImage = this.index.webColunmsList.filter(c => {return c.link == 'ConfigureImage'})
                let yxc
                yxc = ConfigureImage[0].detailList.filter(z => { return z.link == 'yxc'})
                return yxc && yxc.length ? yxc[0].images : ''
            }
          },
          // vr云上展厅pc加载背景图
          pcloadvrhost () {
            if(this.index.webColunmsList.filter(c => {return c.link == 'ConfigureImage'}).length > 0) {
                let ConfigureImage = this.index.webColunmsList.filter(c => {return c.link == 'ConfigureImage'})
                let pcloadvrhost
                pcloadvrhost = ConfigureImage[0].detailList.filter(z => { return z.link == 'pcloadvrhost'})
                return pcloadvrhost && pcloadvrhost.length ? pcloadvrhost[0].images : ''
            }
          },
          // vr云上展厅h5加载背景图
          h5loadvrhost() {
            if(this.index.webColunmsList.filter(c => {return c.link == 'ConfigureImage'}).length > 0) {
                let ConfigureImage = this.index.webColunmsList.filter(c => {return c.link == 'ConfigureImage'})
                let h5loadvrhost
                h5loadvrhost = ConfigureImage[0].detailList.filter(z => { return z.link == 'h5loadvrhost'})
                return h5loadvrhost && h5loadvrhost.length ? h5loadvrhost[0].images : ''
            }
          },
            //  序厅pc加载背景图
          pcloadlobby() {
            if(this.index.webColunmsList.filter(c => {return c.link == 'ConfigureImage'}).length > 0) {
                let ConfigureImage = this.index.webColunmsList.filter(c => {return c.link == 'ConfigureImage'})
                let pcloadlobby
                pcloadlobby = ConfigureImage[0].detailList.filter(z => { return z.link == 'pcloadlobby'})
                return pcloadlobby && pcloadlobby.length ? pcloadlobby[0].images : ''
            }
          },
          //  序厅h5加载背景图
          h5loadlobby() {
            if(this.index.webColunmsList.filter(c => {return c.link == 'ConfigureImage'}).length > 0) {
                let ConfigureImage = this.index.webColunmsList.filter(c => {return c.link == 'ConfigureImage'})
                let h5loadlobby
                h5loadlobby = ConfigureImage[0].detailList.filter(z => { return z.link == 'h5loadlobby'})
                return h5loadlobby && h5loadlobby.length ? h5loadlobby[0].images : ''
            }
          },
          // pc观众登录-展商推送位置
          hotpc() {
            if(this.index.webColunmsList.filter(c => {return c.link == 'ConfigureImage'}).length > 0) {
                let ConfigureImage = this.index.webColunmsList.filter(c => {return c.link == 'ConfigureImage'})
                let hotpc
                hotpc = ConfigureImage[0].detailList.filter(z => { return z.link == 'hotpc'})
                return hotpc && hotpc.length ? hotpc[0].images : ''
            }
          },
          // h5小程序观众登录-广告推送位置
          hoth5() {
            if(this.index.webColunmsList.filter(c => {return c.link == 'ConfigureImage'}).length > 0) {
                let ConfigureImage = this.index.webColunmsList.filter(c => {return c.link == 'ConfigureImage'})
                let hoth5
                hoth5 = ConfigureImage[0].detailList.filter(z => { return z.link == 'hoth5'})
                return hoth5 && hoth5.length ? hoth5[0].images : ''
            }
          },
          //   h5登录前页面背景图
          loginh5Bg() {
            if(this.index.webColunmsList.filter(c => {return c.link == 'ConfigureImage'}).length > 0) {
                let ConfigureImage = this.index.webColunmsList.filter(c => {return c.link == 'ConfigureImage'})
                let loginh5Bg
                loginh5Bg = ConfigureImage[0].detailList.filter(z => { return z.link == 'loginh5Bg'})
                return loginh5Bg && loginh5Bg.length ? loginh5Bg[0].images : ''
            }
          },

    },
    mounted() {
    }
}

export default minXin


// WEBPACK FOOTER //
// ./src/mixins/pageMixins.js